import { SelectItem } from 'primeng/api';
export enum ProductType {
  Product = 'Product',
  Service = 'Service',
  PeriodicalService = 'PeriodicalService',
  PeriodicalServiceCustomer = 'PeriodicalServiceCustomer',
  PackageService = 'PackageService'
}
